import { PublicClientApplication } from '@azure/msal-browser';

// The token a cloud repository was imported with is a bare browser access token
// (about an hour, no refresh token), so a later "Update Repository" needs a fresh one
// from the same sign-in the import used. These helpers get it.

// Same Graph scopes the import requests (addCloudRepo.jsx loginToOneDrive).
const ONEDRIVE_SCOPES = ['Files.ReadWrite.All'];

let msalInstance = null;
let msalClientId = null;

const getMsal = async (clientId) => {
    if (!msalInstance || msalClientId !== clientId) {
        msalInstance = new PublicClientApplication({
            auth: {
                clientId,
                authority: 'https://login.microsoftonline.com/common',
                redirectUri: window.location.origin,
            },
            cache: { cacheLocation: 'localStorage' },
        });
        msalClientId = clientId;
        await msalInstance.initialize();
    }
    return msalInstance;
};

/**
 * Warm up MSAL (initialize is async) ahead of the user's click, so the sign-in popup,
 * if one is needed, opens inside the click and isn't blocked.
 */
export const prepareOneDriveAuth = async (clientId) => {
    if (clientId) await getMsal(clientId);
};

/**
 * A fresh Microsoft Graph access token: silently from the MSAL session cached in this
 * browser when possible, otherwise through the Microsoft sign-in popup.
 */
export const getOneDriveAccessToken = async (clientId) => {
    const msal = await getMsal(clientId);
    const account = msal.getActiveAccount() || msal.getAllAccounts()[0];
    if (account) {
        try {
            const silent = await msal.acquireTokenSilent({ scopes: ONEDRIVE_SCOPES, account });
            return silent.accessToken;
        } catch (e) {
            // Session expired or consent needed: fall through to the popup.
        }
        const popup = await msal.acquireTokenPopup({ scopes: ONEDRIVE_SCOPES, account });
        return popup.accessToken;
    }
    const login = await msal.loginPopup({ scopes: [...ONEDRIVE_SCOPES, 'offline_access'] });
    msal.setActiveAccount(login.account);
    return login.accessToken;
};

// @react-oauth/google 0.7 calls neither callback when the user just closes the popup.
export const GOOGLE_TOKEN_TIMEOUT_MS = 2 * 60 * 1000;
